import {
    DateRangePickerProps,
    DateRangePicker,
} from "@mui/x-date-pickers-pro";


export interface AavoDateRangePickerProps extends DateRangePickerProps {
    errorMessage?: string;
}

export const AavoDateRangePicker = ({
                                        slotProps,
                                        errorMessage,
                                        displayWeekNumber = true,
                                        ...other
                                    }: AavoDateRangePickerProps) => {
    const slotPropsWrapped = {
        ...slotProps,
        textField: {
            ...{
                size: "small" as const,
                error: errorMessage !== undefined,
                helperText: errorMessage,
            },
            ...slotProps?.textField,
        },
    };

    return <DateRangePicker slotProps={slotPropsWrapped}
                            displayWeekNumber={displayWeekNumber}
                            {...other} />;
};
